import { effect, inject, Injectable, NgZone, signal } from '@angular/core';
import type { PostHog } from 'posthog-js';
import { environment } from '@environments/environment';
import { UserResourceService } from '../resources/user-resource.service';

@Injectable({ providedIn: 'root' })
export class PosthogService {
  private ngZone = inject(NgZone);
  private userResourceService = inject(UserResourceService);

  /** Loaded on demand, so the SDK stays out of the initial bundle; unset while loading or disabled. */
  private posthog = signal<PostHog | undefined>(undefined);

  constructor() {
    if (environment.posthog.enabled) {
      void this.initPostHog();
    }

    effect(() => {
      const posthog = this.posthog();
      const user = this.userResourceService.user.value();
      if (!posthog || !user) return;

      posthog.identify('user_ ' + user.id.toString(), {
        email: user.email,
        name: user.firstname + ' ' + user.lastname,
        clientId: user.clientId,
        lastLogin: user.lastLogin,
        isOwner: user.isOwner,
        timezone: user.timezone,
      });
    });
  }

  private async initPostHog() {
    const { default: posthog } = await import('posthog-js');
    this.ngZone.runOutsideAngular(() => {
      posthog.init(environment.posthog.key, {
        api_host: environment.posthog.host,
        defaults: '2025-05-24',
      });
    });
    this.posthog.set(posthog);
  }
}
